
class FactoriesSection extends HTMLElement {

    constructor() {
      super();
      this.init();
    }
  
    setModalContent(modal, factory) {
 
      this.propsToReplace.forEach( prop => {
        modal.querySelector(prop).innerHTML = factory.querySelector(prop)?.innerHTML;
      })
  
      modal.querySelector("[data-img]").src = factory.querySelector("[data-img]").textContent;
  
      return ;
    }
  
    init() {
      this.inited = false;
  
      this.modal = this.querySelector("modal-popup");
      this.factories = this.querySelectorAll("[data-factory]");
      this.propsToReplace = [
        "[data-city]",
        "[data-country]",
        "[data-description]",
        "[data-family-run]",
        "[data-founding-year]",
        "[data-full-time]",
        "[data-employees]",
        "[data-overtime]",
        "[data-employee-benefits]",
        "[data-certifications]"
      ]
  
      this.addEvents();
  
  
      this.inited = true;
    }
  
    addEvents() {
      this.factories.forEach( factory => {
        factory.addEventListener("click", () => {
          this.setModalContent(this.modal, factory);
        })
      })
    }
  
  }
  
  customElements.define('factories-section', FactoriesSection);
  